import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Subject } from "rxjs";
import { StatoFinanziamentoDto } from "../../models/stato-finanziamenti-dashboard-dto";
import {
  DashboardService,
  TipoStrumentoAttuativoService,
  StorageService
} from "../../services";
import { ToastService } from "src/app/services/toast.service";
import * as moment from "moment";
import * as FileSaver from "file-saver";
import { CurrencyPipe } from "@angular/common";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
@Component({
  selector: "app-dashboard-stato-finanziamenti",
  templateUrl: "./dashboard-stato-finanziamenti.component.html",
  styleUrls: ["./dashboard-stato-finanziamenti.component.css"],
})
export class DashboardStatoFinanziamentiComponent implements OnInit, OnDestroy {
  //myForm: FormGroup;
  chartUnoTorta;
  chartUnoBarre;
  chartFonte;
  chartStrumento;
  chartDisponibilita;

  //filtri
  fontiCombo = [];
  strumentiCombo = [];
  areeTematicheCombo = [];
  siNoCombo: Array<{ k: number; v: string }> = [
    { k: 1, v: "Si" },
    { k: 2, v: "No" },
  ];
  anniCombo = [];

  filterFonte = [];
  filterStrumenti = -1;
  filterArea = -1;
  filterSino = -1;
  filterAnno = "all";

  filterFinanziamentoId = [];
  finanziamentoDescription = "";

  finanziamenti: StatoFinanziamentoDto[] = [];
  allFinanziamenti: StatoFinanziamentoDto[] = [];

  completerParams = {};

  showPage = false;
  constructor(
    private formBuilder: FormBuilder,
    private service: DashboardService,
    private strumentoService: TipoStrumentoAttuativoService,
    private toastr: ToastService
    ,private storageService:StorageService
  ) {}

  ngOnInit() {
    this.init();
  }

  filter() {
    this.showPage = false;
    this.disposeCharts();
    this.service
      .getDashboardStatoFinanziamentiData(
        this.filterArea,
        this.filterFonte,
        this.filterStrumenti,
        this.filterSino,
        this.filterAnno,
        this.filterFinanziamentoId
      )
      .subscribe((res) => {
        this.finanziamenti = res;
        if(this.allFinanziamenti.length === 0) {
          this.allFinanziamenti = res;
        }
        //console.log(this.finanziamenti);
        let finEsteso = this.finanziamenti.map(x=>{x['titoloEsteso']=`${x.finanziamentoCodice} - ${x.titolo}`;return x;});
        this.completerParams = {
          items: finEsteso,
          labelField: "titoloEsteso",
          ajax: null,
          placeholder: "Cerca finanziamento ",
        };
        this.drawCharts();
        this.showPage = true;
        this.executeGetTabellaDettaglioObjAsync();
      });
  }

  ngOnDestroy() {
    this.disposeCharts();
    if(this.elencoAreeSubscription)this.elencoAreeSubscription.unsubscribe();
    if(this.elencoTipiFinSubscription)this.elencoTipiFinSubscription.unsubscribe();
  }

  init() {
    am4core.useTheme(am4themes_animated);
    function am4themes_myTheme(target) {
      if (target instanceof am4core.ColorSet) {
        target.list = [
          am4core.color("#67b7dc"),
          //am4core.color("#6794db"),
          am4core.color("#6771dc"),
          //am4core.color("#8067dc"),
          am4core.color("#a367dc"),
          am4core.color("#c767dc"),
        ];
      }
    }

    am4core.useTheme(am4themes_myTheme);
    this.getAreeTematiche();
    this.getFonti();
    this.getStrumentiAttuativo();
    this.getAnni();
    this.filter();
  }

  

  private elencoTipiFinSubscription= null;
    getFonti() {
        this.elencoTipiFinSubscription = this.storageService.elencoTipiFinanziamento.subscribe(
            x=>{
                console.log(x);
                this.fontiCombo = x?x:[];
            }
            );
    }

  setFonte($event) {
    this.filterFonte = ($event && Array.isArray($event)) ?  $event.map(x => x.id) : []; 
    //this.filterFonte = $event ? $event.id : -1;
    //console.log(`aree combo selezionato: ${$event.v}`);
    this.filter();
  }

  getStrumentiAttuativo() {
    this.strumentoService.getAll().subscribe((res) => {
      this.strumentiCombo = res;
    });
  }

  setStrumento($event) {
    this.filterStrumenti = $event ? $event.id : -1;
    this.filter();
  }

  getAnni() {
    const that = this;
    const years = [];
    this.service.getAnniFinanziamenti().subscribe((anni) => {
      anni.map((a) => {
        const anno = { key: a, value: a };
        years.push(anno);
        that.anniCombo = [...years];
      });
      //console.log(that.anniCombo);
    });
  }

  setAnno($event) {
    this.filterAnno = $event && $event.key !== "all" ? $event.key : "all";
    this.filter();
  }

  private elencoAreeSubscription = null;
    getAreeTematiche() {
       
        this.elencoAreeSubscription = this.storageService.elencoAreeTematiche.subscribe(
            x=>{
                console.log(x);
                this.areeTematicheCombo = x?x:[];
            }
            );
    }

  setAreaTematica($event) {
    this.filterArea = $event ? $event.id : -1;
    this.filter();
  }

  setDisponibilita($event) {
    //k=1 => si, k=2 => no
    this.filterSino = $event ? $event.k : -1;
    this.filter();
  }

  //grafici
  countImportoDisponibili(data: StatoFinanziamentoDto[]) {
    let valore = 0.0;
    data.forEach((fin) => {
      if (fin.disponibilita && fin.disponibilita > 0) {
        valore += fin.disponibilita;
      }
    });
    return valore;
  }
  countImportoUtilizzati(data: StatoFinanziamentoDto[]) {
    let valore = 0.0;
    data.forEach((fin) => {
      if (fin.importoFinanziato && fin.importoFinanziato > 0) {
        valore += fin.importoFinanziato;
      }
    });
    return valore;
  }

  countPerStatoValidazione(data: StatoFinanziamentoDto[]): number[] {
    let countValidati = 0;
    let countInAttesa = 0;
    let countDaValidare = 0;
    data.forEach((fin) => {
      switch (fin.statoValidazione) {
        case 1:
          countValidati++;
          break;
        case 4:
        case 5:
          countInAttesa++;
          break;
        default:
          countDaValidare++;
          break;
      }
    });
    return [countValidati, countInAttesa, countDaValidare];
  }

  exportChart(chart, title) {
    chart.exporting.menu = new am4core.ExportMenu();

    // chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {

    //   // Add title to the beginning
    //   pdf.doc.content.unshift({
    //     text: "InfraMob Direzione Regionale Infrastrutture e Mobilità",
    //     margin: [0, 30],
    //     style: {
    //       fontSize: 25,
    //       bold: true,
    //     }
    //   });

    //   return pdf;
    // });
    // chart.exporting.adapter.add("pdfmakeDocument", function(pdf, target) {

    //   // ...

    //   // Add logo
    //   pdf.doc.content.unshift({
    //     image: "data:image/png;base64,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", // actual content removed
    //     fit: [119, 54]
    //   });

    //   return pdf;
    // });

    chart.exporting.menu.align = "left";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.background = "#ff0000";
    chart.exporting.menu.defaultStyles = true;
    chart.exporting.filePrefix = title;

    chart.exporting.menu.items = [
      {
        menu: [
          { type: "jpg", label: "JPG" },
          { type: "png", label: "PNG" },
          { type: "csv", label: "CSV" },
          // { type: "pdf", label: "PDF" },
        ],
      },
    ];
    chart.exporting.menu.items[0].icon = "assets/img/export.png";
    // chart.exporting.dataFields = { disponibile: "nome" };
  }

  aggiungiLogo(logoChart) {
    // Add watermark
    let watermark = new am4core.Image();
    watermark.href = "assets/img/logo_blu.svg";
    logoChart.tooltipContainer.children.push(watermark);
    watermark.align = "right";
    watermark.valign = "bottom";
    watermark.opacity = 0.3;
    watermark.marginRight = 10;
    watermark.marginBottom = 5;
    watermark.disabled = true;

    // Enable watermark on export
    logoChart.exporting.events.on("exportstarted", function (ev) {
      watermark.disabled = false;
    });

    // Disable watermark when export finishes
    logoChart.exporting.events.on("exportfinished", function (ev) {
      watermark.disabled = true;
    });

    // Add watermark to validated sprites
    logoChart.exporting.validateSprites.push(watermark);
  }

  printValueAsCurrency(value) {
    value = typeof value === "number" ? value : value.replace(",", ".").trim();
    const format = "1.2-2";
    const currency = "€";
    const currentLocale: string = "it";
    return new CurrencyPipe(currentLocale).transform(
      value,
      "EUR",
      currency,
      format,
      "it-IT"
    );
  }

  drawChartValoreFinanziamentii() {
    // Themes begin
    this.chartUnoTorta = am4core.create("chart1", am4charts.PieChart);

    this.chartUnoTorta.language.locale = am4lang_it_IT;
    this.chartUnoTorta.numberFormatter.numberFormat = "#.## a '€'";
    this.chartUnoTorta.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "Mln" },
      { number: 1e9, suffix: "Mrd" },
    ];

    // Add chart title
    let title = this.chartUnoTorta.titles.create();
    title.marginTop = 15;
    title.marginBottom = 10;
    title.text = "Valore finanziamenti";

    this.aggiungiLogo(this.chartUnoTorta);

    // Do not add URL
    this.chartUnoTorta.exporting.getFormatOptions("pdf").addURL = false;

    let countDisponibili = this.countImportoDisponibili(this.finanziamenti);
    let countUtilizzati = this.countImportoUtilizzati(this.finanziamenti);

    const roundedDisp = (Math.round(countDisponibili * 100) / 100).toFixed(2);
    const roundedUtil = (Math.round(countUtilizzati * 100) / 100).toFixed(2);

    // Add data
    this.chartUnoTorta.data = [
      {
        name: "disponibili",
        size: roundedDisp,
      },
      { name: "destinati", size: roundedUtil },
    ];

    // Add label
   
    let label = this.chartUnoTorta.seriesContainer.createChild(am4core.Label);
    label.text = this.printValueAsCurrency(
      (Math.round((countDisponibili + countUtilizzati) * 100) / 100).toFixed(2)
    );

    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 20;
    label.zIndex = 100;

    // Add a legend
    this.chartUnoTorta.legend = new am4charts.Legend();
    this.chartUnoTorta.legend.position = "right";
    let markerTemplate = this.chartUnoTorta.legend.markers.template;
    markerTemplate.width = 14;
    markerTemplate.height = 14;
    //chart.legend.itemContainers.template.clickable = false;
    //chart.legend.itemContainers.template.focusable = false;
    this.chartUnoTorta.legend.itemContainers.template.cursorOverStyle =
      am4core.MouseCursorStyle.default;

    this.chartUnoTorta.legend.itemContainers.template.togglable = false;

    this.chartUnoTorta.radius = am4core.percent(90);
    this.chartUnoTorta.innerRadius = am4core.percent(70);
    this.chartUnoTorta.padding =0;
    // Add and configure Series
    let pieSeries = this.chartUnoTorta.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "size";
    pieSeries.dataFields.category = "name";
    //this.chartUnoTorta.numberFormatter.numberFormat = "#.#";
    this.exportChart(this.chartUnoTorta, title.text);
  }

  drawChartBarre() {
    this.chartUnoBarre = am4core.create("chartLast", am4charts.XYChart);
    this.chartUnoBarre.scrollbarX = new am4core.Scrollbar();
    this.chartUnoBarre.language.locale = am4lang_it_IT;

    
    // Add chart title
    let title = this.chartUnoBarre.titles.create();
    //title.marginTop = 15;
    title.marginBottom = 10;
    title.text = "Stato finanziamenti";

    //this.chartUnoBarre.padding = 0;

    this.aggiungiLogo(this.chartUnoBarre);

    // Do not add URL
    this.chartUnoBarre.exporting.getFormatOptions("pdf").addURL = false;

    const counts = this.countPerStatoValidazione(this.finanziamenti);
    // Add data
    this.chartUnoBarre.data = [
      {
        tipo: "Validati",
        valore: counts[0],
      },
      {
        tipo: "In attesa di validazione",
        valore: counts[1],
      },
      {
        tipo: "Da validare",
        valore: counts[2],
      },
    ];

    // Create axes
    let categoryAxis = this.chartUnoBarre.xAxes.push(
      new am4charts.CategoryAxis()
    );
    categoryAxis.dataFields.category = "tipo";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.horizontalCenter = "middle";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    //categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.tooltip.disabled = true;
    //categoryAxis.renderer.minHeight = 110;

    //categoryAxis.renderer.labels.template.paddingBottom = 0


    let valueAxis = this.chartUnoBarre.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minWidth = 50;
    valueAxis.tooltip.disabled = true;
    valueAxis.min = 0;

    // Enable export
    this.exportChart(this.chartUnoBarre, title.text);
    // Create series
    let series = this.chartUnoBarre.series.push(new am4charts.ColumnSeries());
    series.sequencedInterpolation = true;
    series.dataFields.valueY = "valore";
    series.dataFields.categoryX = "tipo";
    series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
    series.columns.template.strokeWidth = 0;

    series.tooltip.pointerOrientation = "vertical";

    series.columns.template.column.cornerRadiusTopLeft = 10;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.fillOpacity = 0.8;

    var bullet = series.bullets.push(new am4charts.LabelBullet());
    bullet.interactionsEnabled = false;
    bullet.locationY = 0.5;

    bullet.label.text = "{valueY}";
    //bullet.label.fill = am4core.color('#ffffff')

    // on hover, make corner radiuses bigger
    let hoverState = series.columns.template.column.states.create("hover");
    hoverState.properties.cornerRadiusTopLeft = 0;
    hoverState.properties.cornerRadiusTopRight = 0;
    hoverState.properties.fillOpacity = 1;
    const that = this;
    series.columns.template.adapter.add("fill", function (fill, target) {
      return that.chartUnoBarre.colors.getIndex(target.dataItem.index);
    });

    // Cursor
    this.chartUnoBarre.cursor = new am4charts.XYCursor();
    this.chartUnoBarre.cursor.lineY.disabled = true;
    this.chartUnoBarre.cursor.lineX.disabled = true;

    this.exportChart(this.chartUnoBarre, title.text);
  }

  drawChartFonte() {
    // Create chart instance
    let fonti = [];
    this.finanziamenti.forEach((fin) => {
      if (fin.tipoFonte.id > 0) {
        let fonte = {};
        //console.log(fin.importoFinanziato);
        if (fin.tipoFonte.tipoFinanziamento && !fonti["" + fin.tipoFonte.id]) {
          //nuovo
          fonte["nome"] = fin.tipoFonte.tipoFinanziamento;
          if (!fonte["disponibile"]) {
            fonte["disponibile"] = 0.0;
          }
          if (!fonte["utilizzato"]) {
            fonte["utilizzato"] = 0.0;
          }
          fonte["disponibile"] += fin.disponibilita ? fin.disponibilita : 0.0;
          fonte["utilizzato"] += fin.importoFinanziato
            ? fin.importoFinanziato
            : 0.0;
          fonti["" + fin.tipoFonte.id] = fonte;
        } else {
          //gia presente
          fonte = fonti["" + fin.tipoFonte.id];

          fonte["disponibile"] += fin.disponibilita ? fin.disponibilita : 0.0;
          fonte["utilizzato"] += fin.importoFinanziato
            ? fin.importoFinanziato
            : 0.0;
        }
      }
    });

    const data = [];
    fonti.forEach((element) => {
      //console.log(element);
      element["none"] = 0;
      data.push(element);
    });

    this.chartFonte = am4core.create("chart2", am4charts.XYChart);

    this.chartFonte.language.locale = am4lang_it_IT;
    this.chartFonte.scrollbarX = new am4core.Scrollbar();
    //this.chartFonte.scrollbarY = new am4core.Scrollbar();

    // Add chart title
    var title = this.chartFonte.titles.create();

    this.aggiungiLogo(this.chartFonte);

    title.marginBottom = 10;
    title.text = "Finanziamenti per fonte";

    // Add data
    this.chartFonte.data = data;
    // Create axes
    let categoryAxis = this.chartFonte.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "nome";
    categoryAxis.renderer.grid.template.location = 0;

    categoryAxis.renderer.labels.template.fontSize = 12;

    let label = categoryAxis.renderer.labels.template;
    label.wrap = true;
    label.maxWidth = 210;

    let valueAxis = this.chartFonte.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.min = 0;
    valueAxis.calculateTotals = true;

    valueAxis.extraMax = 0.1; // aggiungo un 10% sopra l'ultima colonna

    let that = this;

    createSeries("disponibile", "disponibile");
    createSeries("utilizzato", "destinato");

    var totalSeries = this.chartFonte.series.push(new am4charts.ColumnSeries());
    totalSeries.dataFields.valueY = "none";
    totalSeries.dataFields.categoryX = "nome";
    totalSeries.stacked = true;
    totalSeries.hiddenInLegend = true;
    totalSeries.columns.template.strokeOpacity = 0;

    var totalBullet = totalSeries.bullets.push(new am4charts.LabelBullet());
    totalBullet.dy = -20;
    totalBullet.label.text = "[bold]Totale: {valueY.total}[/}";
    totalBullet.label.hideOversized = false;
    totalBullet.label.fontSize = 14;
    totalBullet.label.background.fill = totalSeries.stroke;
    totalBullet.label.background.fillOpacity = 0;
    totalBullet.label.padding(5, 0, 5, 0);

    // Create series

    function createSeries(field, name) {
      // Set up series
      let series = that.chartFonte.series.push(new am4charts.ColumnSeries());
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "nome";
      series.sequencedInterpolation = true;
      series.columns.template.column.fillOpacity = 0.8;

      // Make it stacked
      series.stacked = true;

      // let label = categoryAxis.renderer.labels.template;

      // label.tooltipText = "[bold]Totale: {totale}";

      // Configure columns
      series.columns.template.width = am4core.percent(70);
      series.columns.template.tooltipText =
        "[bold]{name}: {valueY}[/]\n[font-size:14px]{categoryX}";

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      return series;
    }
    // Enable export
    this.exportChart(this.chartFonte, title.text);
    // Legend
    this.chartFonte.legend = new am4charts.Legend();

    let markerTemplate = this.chartFonte.legend.markers.template;
    markerTemplate.width = 14;
    markerTemplate.height = 14;
    this.chartFonte.events.on("ready", () => {
      let asse = that.chartFonte.xAxes.values[0];
      let catCount = that.chartFonte.data.length;
      if (catCount > 0 && catCount > 10) asse.zoomToIndexes(0, 10);
    });

    this.chartFonte.numberFormatter.numberFormat = "#.## a '€'";
    this.chartFonte.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "Mln" },
      { number: 1e9, suffix: "Mrd" },
    ];
  }
  drawChartStrumento() {
    // Create chart instance

    const data = [];
    let strumenti = [];
    this.finanziamenti.forEach((fin) => {
      if (fin.tipoStrumentoAttuativo.id > 0) {
        let strumento = {};
        console.log(fin.importoFinanziato);
        if (
          fin.tipoStrumentoAttuativo.descrizione &&
          !strumenti["" + fin.tipoStrumentoAttuativo.id]
        ) {
          //nuovo

          strumento["nome"] = fin.tipoStrumentoAttuativo.descrizione;

          if (!strumento["utilizzato"]) {
            strumento["utilizzato"] = 0.0;
          }
          if (!strumento["disponibile"]) {
            strumento["disponibile"] = 0.0;
          }
          strumento["disponibile"] = fin.disponibilita
            ? fin.disponibilita
            : 0.0;
          strumento["utilizzato"] = fin.importoFinanziato
            ? fin.importoFinanziato
            : 0.0;

          strumenti["" + fin.tipoStrumentoAttuativo.id] = strumento;
        } else {
          //gia presente
          strumento = strumenti["" + fin.tipoStrumentoAttuativo.id];

          strumento["disponibile"] += fin.disponibilita
            ? fin.disponibilita
            : 0.0;
          strumento["utilizzato"] += fin.importoFinanziato
            ? fin.importoFinanziato
            : 0.0;
        }
      }
    });

    strumenti.forEach((element) => {
      //console.log(element);
      element["none"] = 0;
      data.push(element);
    });
    this.chartStrumento = am4core.create("chart3", am4charts.XYChart);
    this.chartStrumento.language.locale = am4lang_it_IT;
    this.chartStrumento.scrollbarX = new am4core.Scrollbar();

    // Add chart title
    var title = this.chartStrumento.titles.create();

    this.aggiungiLogo(this.chartStrumento);

    // Do not add URL
    this.chartStrumento.exporting.getFormatOptions("pdf").addURL = false;

    title.marginBottom = 10;
    title.text = "Finanziamenti per strumento attuativo";

    // Add data
    this.chartStrumento.data = data;
    // Create axes
    let categoryAxis = this.chartStrumento.xAxes.push(
      new am4charts.CategoryAxis()
    );
    categoryAxis.dataFields.category = "nome";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.labels.template.fontSize = 12;

    let label = categoryAxis.renderer.labels.template;
    label.wrap = true;
    label.maxWidth = 210;

    let valueAxis = this.chartStrumento.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.min = 0;
    valueAxis.calculateTotals = true;
    let that = this;
    createSeries("disponibile", "disponibile");
    createSeries("utilizzato", "destinato");
    this.chartStrumento.numberFormatter.numberFormat = "#.## a '€'";
    this.chartStrumento.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "Mln" },
      { number: 1e9, suffix: "Mrd" },
    ];
    var totalSeries = this.chartStrumento.series.push(
      new am4charts.ColumnSeries()
    );
    totalSeries.dataFields.valueY = "none";
    totalSeries.dataFields.categoryX = "nome";
    totalSeries.stacked = true;
    totalSeries.hiddenInLegend = true;
    totalSeries.columns.template.strokeOpacity = 0;

    var totalBullet = totalSeries.bullets.push(new am4charts.LabelBullet());
    totalBullet.dy = -20;
    totalBullet.label.text = "[bold]Totale: {valueY.total}[/}";
    totalBullet.label.hideOversized = false;
    totalBullet.label.fontSize = 14;
    totalBullet.label.background.fill = totalSeries.stroke;
    totalBullet.label.background.fillOpacity = 0;
    totalBullet.label.padding(5, 0, 5, 0);

    // Enable export Luca
    this.chartStrumento.exporting.menu = new am4core.ExportMenu();
    this.chartStrumento.exporting.menu.align = "left";
    this.chartStrumento.exporting.menu.verticalAlign = "top";
    //this.chartStrumento.exporting.menu.background = "#ff0000";
    this.chartStrumento.exporting.menu.items[0].icon = "assets/img/export.png";
    this.chartStrumento.exporting.menu.defaultStyles = true;
    // Create series

    function createSeries(field, name) {
      // Set up series
      let series = that.chartStrumento.series.push(
        new am4charts.ColumnSeries()
      );
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "nome";
      series.sequencedInterpolation = true;
      series.columns.template.column.fillOpacity = 0.8;
      // Make it stacked
      series.stacked = true;

      // let label = categoryAxis.renderer.labels.template;

      // label.tooltipText = "[bold]Totale: {totale}";

      // Configure columns
      series.columns.template.width = am4core.percent(70);
      series.columns.template.tooltipText =
        "[bold]{name}: {valueY}[/]\n[font-size:14px]{categoryX}";

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      return series;
    }

    // Legend
    this.chartStrumento.legend = new am4charts.Legend();

    let markerTemplate = this.chartStrumento.legend.markers.template;
    markerTemplate.width = 14;
    markerTemplate.height = 14;
    this.chartStrumento.events.on("ready", () => {
      let asse = that.chartStrumento.xAxes.values[0];
      let catCount = that.chartStrumento.data.length;
      if (catCount > 0 && catCount > 10) asse.zoomToIndexes(0, 10);
    });

    this.exportChart(this.chartStrumento, title.text);
  }
  drawChartDisponibilita() {
    // Create chart instance
    let anni = [];
    this.finanziamenti.forEach((fin) => {
      //console.log(this.anniCombo);
      this.anniCombo.forEach((anno) => {
        let element = {};
        const label = "anno_" + anno.key;
        if (!anni[label]) {
          //console.log();
          const a =fin.annualita? fin.annualita.find((af) => af.anno.toString() == anno.key):null;
          if (a) {
            //console.log(a);
            element["nome"] = anno.key;
            element["disponibile"] = a ? a.disponibilita : 0;
            element["utilizzato"] = a ? a.impegnato : 0;
            anni[label] = element;
          }
        } else {
          const a = fin.annualita?fin.annualita.find((af) => af.anno.toString() == anno.key):null;
          //console.log(a);
          if (a) {
            anni[label].disponibile += a ? a.disponibilita : 0;
            //anni[label].utilizzati += a ? a.impegnato : 0;
            anni[label].utilizzato += a ? a.impegnato : 0;
          }
        }
      });
    });

    this.chartDisponibilita = am4core.create("chart4", am4charts.XYChart);
    this.chartDisponibilita.scrollbarX = new am4core.Scrollbar();
    this.chartDisponibilita.language.locale = am4lang_it_IT;
    // Add chart title
    var title = this.chartDisponibilita.titles.create();

    this.aggiungiLogo(this.chartDisponibilita);

    title.marginBottom = 10;
    title.text = "Finanziamenti per annualità";

    const data = [];
    Object.keys(anni).forEach(function (x) {
      anni[x]["none"] = 0;
      data.push(anni[x]);
    });

    data.sort((a, b) => {
      return a["nome"] > b["nome"] ? 1 : a.nome < b.nome ? -1 : 0;
    });
    this.chartDisponibilita.data = data;
    //this.chartDisponibilita.data = data;
    // Create axes
    let categoryAxis = this.chartDisponibilita.xAxes.push(
      new am4charts.CategoryAxis()
    );
    categoryAxis.dataFields.category = "nome";
    categoryAxis.renderer.grid.template.location = 0;
    

    

    let valueAxis = this.chartDisponibilita.yAxes.push(
      new am4charts.ValueAxis()
    );
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.min = 0;
    valueAxis.calculateTotals = true;
    valueAxis.extraMax = 0.1; // aggiungo un 10% sopra l'ultima colonna
    let that = this;
    createSeries("disponibile", "disponibile");
    createSeries("utilizzato", "destinato");
    this.chartDisponibilita.numberFormatter.numberFormat = "#.## a '€'";
    this.chartDisponibilita.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "Mln" },
      { number: 1e9, suffix: "Mrd" },
    ];
    var totalSeries = this.chartDisponibilita.series.push(
      new am4charts.ColumnSeries()
    );
    totalSeries.dataFields.valueY = "none";
    totalSeries.dataFields.categoryX = "nome";
    totalSeries.stacked = true;
    totalSeries.hiddenInLegend = true;
    totalSeries.columns.template.strokeOpacity = 0;

    var totalBullet = totalSeries.bullets.push(new am4charts.LabelBullet());
    totalBullet.dy = -20;
    totalBullet.label.text = "[bold]Totale: {valueY.total}[/}";
    totalBullet.label.hideOversized = false;
    totalBullet.label.fontSize = 14;
    totalBullet.label.background.fill = totalSeries.stroke;
    totalBullet.label.background.fillOpacity = 0;
    totalBullet.label.padding(0, 0, 0, 0);

    // Create series

    function createSeries(field, name) {
      // Set up series
      let series = that.chartDisponibilita.series.push(
        new am4charts.ColumnSeries()
      );
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "nome";
      series.sequencedInterpolation = true;
      series.columns.template.column.fillOpacity = 0.8;

      // Make it stacked
      series.stacked = true;

      // let label = categoryAxis.renderer.labels.template;

      // label.tooltipText = "[bold]Totale: {totale}";

      // Configure columns
      series.columns.template.width = am4core.percent(70);
      series.columns.template.tooltipText =
        "[bold]{name}: {valueY}[/]\n[font-size:14px]{categoryX}";

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      return series;
    }

    // Legend
    this.chartDisponibilita.legend = new am4charts.Legend();

    let markerTemplate = this.chartDisponibilita.legend.markers.template;
    markerTemplate.width = 14;
    markerTemplate.height = 14;
    this.chartDisponibilita.events.on("ready", () => {
      let asse = that.chartDisponibilita.xAxes.values[0];
      let catCount = that.chartDisponibilita.data.length;
      if (catCount > 0 && catCount > 10) asse.zoomToIndexes(0, 10);
    });

    this.exportChart(this.chartDisponibilita, title.text);
    // Do not add URL
    this.chartDisponibilita.exporting.getFormatOptions("pdf").addURL = false;
  }

  drawCharts() {
    this.drawChartValoreFinanziamentii();
    this.drawChartBarre();
    this.drawChartFonte();
    this.drawChartStrumento();
    this.drawChartDisponibilita();
  }

  disposeCharts() {
    this.chartUnoTorta && this.chartUnoTorta.dispose();
    this.chartUnoBarre && this.chartUnoBarre.dispose();
    this.chartFonte && this.chartFonte.dispose();
    this.chartStrumento && this.chartStrumento.dispose();
    this.chartDisponibilita && this.chartDisponibilita.dispose();
  }

  //tabella di dettaglio
  tabellaDettaglioObj: any;
  tabellaDettaglioObjArrayAnni: any;
  tabellaDettaglioObjLoaded = false;
  subjectTabDettaglio = new Subject<any>();
  observable$ = this.subjectTabDettaglio.asObservable();

  async executeGetTabellaDettaglioObjAsync() {
    this.tabellaDettaglioObjLoaded = false;
    return new Promise((resolve) => {
      //console.log(`dentro executeGetTabellaDettaglioObjAsync`);
      this.getTabellaDettaglioObj(this.finanziamenti);
    });
  }

  getTabellaDettaglioObj(finanziamenti) {
    this.tabellaDettaglioObj = finanziamenti;

    this.subjectTabDettaglio.next(this.tabellaDettaglioObj);

    //this.tabellaDettaglioObjLoaded = true;
  }

  loadingExportExcel = false;

  esportaExcel() {
    this.loadingExportExcel = true;
    this.service
      .getDashboardStatoFinanziamentiDetailTableDataExport(
        this.filterArea,
        this.filterFonte,
        this.filterStrumenti,
        this.filterSino,
        this.filterAnno,
        this.filterFinanziamentoId
      )
      .subscribe(
        (res) => {
          let filename = `esportazione_stato_finanziamenti_${moment(
            new Date()
          ).format("YYYY_MM_DDTHH_mm_ss")}.xlsx`;
          FileSaver.saveAs(res.body, `${filename}`);
          this.loadingExportExcel = false;
        },
        (error) => {
          this.toastr.error(
            `Errore: ${
              error.error.message
                ? error.error.message
                : error.error.error_description
                ? error.error.error_description
                : error.error
            }`,
            null,
            {
              timeOut: 2000,
              disableTimeOut: false,
            }
          );
          //console.log("error");
          this.loadingExportExcel = false;
        }
      );
  }

  setFinanziamento($event) {
    //this.f.status.enable();

    this.filterFinanziamentoId = ($event && Array.isArray($event)) ?  $event.map(x => x.finanziamentoId) : []; 
    //this.filterFinanziamentoId = $event ? $event.finanziamentoId : -1;
    this.finanziamentoDescription = $event && $event.titolo;
    this.filter();
  }

  onChangeFinaziamento($event) {
    !$event.target.value && this.setFinanziamento(null);
  }
}
